import React from 'react';

import Hero from './components/Hero';
import ContactIntro from './components/ContactIntro';


export default class extends React.Component {

  render() {
    document.title = "Gratis & Waardevol - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div>

        <Hero
          h1split1="Gratis "
          h1split2="& Waardevol"
          h2="Sterke bedrijven verliezen kansen wanneer de Founder onzichtbaar blijft."
        />

        <i id="eenmalige-diensten"/>
        <div className="full big black">
          <div className="wrap content-block">

            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <div style={{marginTop:"2em"}}>
                <div style={{background:"#E5C88D", color:"#000", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black", fontWeight:"bold", fontSize:"1.5em"}}>Werving Check</div>
                <div className="card more-rounded card-black">
                  <p style={{marginBottom:"1em"}}>Waarom trekken sommige vacatures direct sterke kandidaten aan.. terwijl andere compleet genegeerd worden?<br/><br/>De Werving Check laat zien waar jouw zichtbaarheid kansen laat liggen.<br/><br/>Klik op deze knop om dit direct in te vullen:</p>
                  <div style={{textAlign:"center", marginBottom:"1.7em"}}><a href="https://ghostin-werving-check.scoreapp.com/" target="blank" className="btn btn-fat btn-if btn-if-fill-gold" style={{boxShadow:"3px 3px black"}}>Invullen <span style={{fontSize:"150%", lineHeight:"0"}}>&rarr;</span></a></div>
                </div>
              </div>
            </div>

            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <div style={{marginTop:"2em"}}>
                <div style={{background:"#E5C88D", color:"#000", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black", fontWeight:"bold", fontSize:"1.5em"}}>Uitgebreide Profiel Analyse</div>
                <div className="card more-rounded card-black">
                  <p style={{marginBottom:"1em"}}>Jouw LinkedIn-profiel is vaak het eerste wat talent ziet nadat ze jouw bedrijf ontdekken.<br/><br/>Deze analyse laat zien of jouw profiel vertrouwen opbouwt.. of juist interesse verliest.<br/><br/>Klik op deze knop om dit gratis en vrijblijvend aan te vragen via een LinkedIn DM:</p>
                  <div style={{textAlign:"center", marginBottom:"1.7em"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-fat btn-if btn-if-fill-gold" style={{boxShadow:"3px 3px black"}}>Aanvragen <span style={{fontSize:"150%", lineHeight:"0"}}>&rarr;</span></a></div>
                </div>
              </div>
            </div>

            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <div style={{marginTop:"2em"}}>
                <div style={{background:"#E5C88D", color:"#000", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black", fontWeight:"bold", fontSize:"1.5em"}}>"Waarom goede vacatures genegeerd worden"</div>
                <div className="card more-rounded card-black">
                  <p style={{marginBottom:"1em"}}>Je hebt waarschijnlijk geen wervingprobleem.<br/><br/>Je hebt een aandachtstekort.<br/><br/>De meeste CEO's verschijnen pas op LinkedIn wanneer er een vacature openstaat. Tegen die tijd kent bijna niemand het verhaal achter het bedrijf.<br/><br/>In deze gratis gids leer je waarom zichtbaarheid een recruitmentstrategie is, en hoe je voorkomt dat goede vacatures onzichtbaar blijven. Klik op deze knop:</p>
                  <div style={{textAlign:"center", marginBottom:"1.7em"}}><a href="https://docs.google.com/document/d/1FWVtHFzEP30_MT3V6gojm_pxPF05y7WI_uttRDGD6pU/edit?usp=sharing" target="blank" className="btn btn-fat btn-if btn-if-fill-gold" style={{boxShadow:"3px 3px black"}}>Openen (zonder e-mail) <span style={{fontSize:"150%", lineHeight:"0"}}>&rarr;</span></a></div>
                </div>
              </div>
            </div>

            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <div style={{marginTop:"2em"}}>
                <div style={{background:"#E5C88D", color:"#000", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black", fontWeight:"bold", fontSize:"1.5em"}}>Eén #hiring-post herschrijven</div>
                <div className="card more-rounded card-black">
                  <p style={{marginBottom:"1em"}}>De meeste hiring posts voelen als een oproep, en meer niet.<br/><br/>Ik herschrijf één vacaturepost zodat mensen niet alleen de functie zien.. maar ook waarom ze juist bij jullie willen werken.<br/><br/>Klik op deze knop om dit gratis en vrijblijvend aan te vragen via een LinkedIn DM:</p>
                  <div style={{textAlign:"center", marginBottom:"1.7em"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-fat btn-if btn-if-fill-gold" style={{boxShadow:"3px 3px black"}}>Aanvragen <span style={{fontSize:"150%", lineHeight:"0"}}>&rarr;</span></a></div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/LeadMagnets.js